import {
  GET_IN_LAN_DONG_LAI,
  GET_IN_LAN_DONG_LAI_SUCCESS,
  GET_IN_LAN_DONG_LAI_FAILURE,
} from "actions/InLanDongLai/actionTypes";

const initialState = {
  inLanDongLaiLoading: false,
  NoiDungIn: "",
};

const getInLanDongLai = (state, action) => ({
  ...state,
  inLanDongLaiLoading: true,
});

const getInLanDongLaiSuccess = (state, action) => {
  return {
    ...state,
    inLanDongLaiLoading: false,
    NoiDungIn: action.payload,
  };
};

const getInLanDongLaiFailed = (state, action) => ({
  ...state,
  inLanDongLaiLoading: false,
  NoiDungIn: "",
});

const inLanDongLaiReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_IN_LAN_DONG_LAI:
      return getInLanDongLai(state, action);
    case GET_IN_LAN_DONG_LAI_SUCCESS:
      return getInLanDongLaiSuccess(state, action);
    case GET_IN_LAN_DONG_LAI_FAILURE:
      return getInLanDongLaiFailed(state, action);
    default:
      return state;
  }
};

export default inLanDongLaiReducer;
